import * as selection from 'd3-selection'
import * as shape from 'd3-shape'
import * as scale from 'd3-scale'
import * as array from 'd3-array'
import * as axis from 'd3-axis'
import * as timeFormat from 'd3-time-format'
import * as time from 'd3-time'
import * as format from 'd3-format'
import * as drag from 'd3-drag'
import * as transition from 'd3-transition'
import * as ease from 'd3-ease'

export default Object.assign(
  {},
  selection,
  shape,
  scale,
  array,
  axis,
  timeFormat,
  time,
  format,
  drag,
  transition,
  ease
)
